import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBEM, useI18n } from "@geome/react-next";
import { useIconFor } from "../properties/hooks/useIconFor";
export const Tabs = ({ icons, countryCode, connectorData, types, selectedType, setSelectedType, }) => {
    return (_jsx("ul", { className: "ev-charging-section__tabs", children: types.map((type) => {
            const connector = connectorData.find((cd) => cd.type === type);
            if (!connector)
                return null;
            return (_jsx(Tab, { type: type, selected: selectedType === type, onSelect: () => setSelectedType(type), connector: connector, countryCode: countryCode, icons: icons }, type));
        }) }));
};
const Tab = ({ type, onSelect, connector, icons, countryCode, selected }) => {
    const { translate } = useI18n();
    const hasAvailability = connector.available !== undefined;
    const className = useBEM({
        block: "ev-charging-section",
        element: "tab",
        modifiers: {
            active: selected,
            available: hasAvailability ? (connector.available ?? 0) > 0 : false,
            unavailable: hasAvailability ? (connector.available ?? 0) === 0 : false,
        },
    });
    const iconKey = `ev-connectors.${type}`;
    const iconSrc = useIconFor(iconKey, countryCode, icons);
    return (_jsxs("li", { className: className, onClick: onSelect, onKeyDown: (k) => (k.key === "Enter" ? onSelect : null), role: "button", tabIndex: 0, children: [_jsx("img", { src: iconSrc, width: "16", height: "16", alt: translate(`ev_connector_types.${type}`), title: translate(`ev_connector_types.${type}`), className: "ev-charging-section__tab-icon" }), _jsx("span", { children: translate(`ev_connector_types.${type}`) })] }));
};
